<div class="cart-preview-info">

  <div class="d-flex p-2">
    @if (config?.displayHeaderTitle == true) {
      <span i18n="@@CartPreviewYourCartLabel">Your cart </span>
    }
    <span class="ms-auto"></span>
    <a class="c-pointer" (click)="cartCreationDialogShowAsync(config?.cart, false)" data-bs-dismiss="offcanvas"
    i18n="@@CartPreviewEditCartLabel">Edit</a>
  </div>

  <ng-content/>

  <app-delivery-date [deliveryDate]="config?.cart?.deliveryDate"></app-delivery-date>

</div>
